import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { useState } from 'react';

const PriceCardFAQ = ({ faqlist, faqTitle, faqSubTitle, faqLink, linkDirection }) => {
    const [expandedId, setExpandedId] = useState(null);
    const handleChange = (faqItemId) => {
        if (expandedId === faqItemId) {
            setExpandedId(null);
        } else {
            setExpandedId(faqItemId);
        }
    };
    return (
        <div className="pricing-card-wrapper-shareholder-faq pricing-card-faq">
            <Typography variant="p" className="text-title">
                {faqTitle}
            </Typography>
            <Typography variant="p" component="span" className="text-subtitle fw-400">
                {faqSubTitle}
                <Typography
                    variant="p"
                    onClick={() => {
                        window.open(linkDirection, '_blank');
                    }}
                    component="span"
                    className="text-link fw-500"
                    ml="5px"
                >
                    {faqLink}
                </Typography>
            </Typography>

            {faqlist?.map((faqItem) => {
                return (
                    <Accordion
                        expanded={faqItem.id === expandedId}
                        className={`faq-list-item`}
                        onChange={() => handleChange(faqItem.id)}
                        key={faqItem.id}
                        sx={{
                            flex: 1 // This will make the accordion items fill the available vertical space evenly
                        }}
                    >
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <Typography className="faq-list-title-description fw-400">{faqItem.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography className="faq-list-title-description fw-400">{faqItem.description}</Typography>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </div>
    );
};
export default PriceCardFAQ;
